var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.52 61.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9943a;\n      }\n\n      .cls-2 {\n        fill: #f9a25a;\n      }\n\n      .cls-3 {\n        fill: #000201;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #fff6ee;\n      }\n\n      .cls-6 {\n        fill: #ffcd9f;\n      }\n\n      .cls-7 {\n        fill: #fbb570;\n      }\n\n      .cls-8 {\n        fill: #2ff382;\n      }\n\n      .cls-9, .cls-10 {\n        fill: #d07828;\n      }\n\n      .cls-11 {\n        fill: #d3670d;\n      }\n\n      .cls-12, .cls-13 {\n        fill: #06cb56;\n      }\n\n      .cls-14 {\n        fill: #61ffa0;\n      }\n\n      .cls-13 {\n        isolation: isolate;\n        opacity: .6;\n      }\n\n      .cls-10 {\n        opacity: .67;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 44.64,
    cy: 13.51,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 39.4,
    cy: 6,
    r: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 41.82,
    cy: 8.63,
    r: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.89,15.29c-.28,0-.54-.1-.75-.29l-4.02-3.59c-.47-.41-.51-1.12-.1-1.59,.41-.47,1.12-.51,1.59-.1h0l3.13,2.81,4.78-5.99c.36-.51,1.06-.63,1.56-.28,.51,.36,.63,1.06,.28,1.56-.03,.04-.06,.08-.09,.11l-5.52,6.92c-.19,.24-.48,.4-.79,.42h-.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 34.32,
    cy: 5.66,
    r: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.01,26.38c-.43,0-.79-.33-.84-.75-.05-.46,.28-.87,.74-.93,0,0,0,0,0,0h0c.2,0,4.79-.62,7.69-5.66,.23-.4,.75-.55,1.15-.31,.4,.23,.55,.75,.31,1.15h0c-3.37,5.81-8.74,6.47-8.99,6.5h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M42.58,26.21c-.05,0-.1,0-.16,0-.96-.18-1.9-.45-2.81-.83-.42-.2-.6-.7-.4-1.12,.2-.42,.7-.6,1.12-.4,.77,.31,1.57,.54,2.39,.69,.46,.09,.76,.53,.67,.99-.08,.39-.43,.67-.83,.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.64,27.03c-7.46,0-13.52-6.04-13.52-13.5,0-2.32,.59-4.6,1.73-6.63,.13-.24,.44-.33,.68-.2,0,0,0,0,0,0,.24,.14,.33,.45,.2,.69-3.38,6.01-1.24,13.63,4.77,17.01,6.01,3.38,13.63,1.24,17.01-4.77,3.38-6.01,1.24-13.63-4.77-17.01-4.86-2.73-10.95-1.91-14.91,2.02-.2,.2-.52,.2-.71,0-.2-.2-.2-.52,0-.72,5.3-5.26,13.85-5.22,19.11,.08,5.26,5.3,5.22,13.85-.08,19.11-2.53,2.51-5.95,3.92-9.52,3.92h.02Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.79,
    y: 17.44,
    width: 37.7,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 12.02,
    y: 17.22,
    width: 37.7,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.73,60.73H15.84c-.57,0-1.02-.46-1.03-1.02,0-.57,.46-1.02,1.02-1.03h24.89c.57,0,1.02,.46,1.03,1.02,0,.57-.46,1.02-1.02,1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37.79,36.74H12.9c-.57,0-1.02-.46-1.03-1.02,0-.57,.46-1.02,1.02-1.03h24.89c.57,0,1.02,.46,1.03,1.02,0,.57-.46,1.02-1.02,1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M72.53,36.83h-10.18c-.57,0-1.02-.46-1.03-1.02,0-.57,.46-1.02,1.02-1.03h10.18c.57,0,1.02,.46,1.03,1.02,0,.57-.46,1.02-1.02,1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.72,61.72H12.02c-.28,0-.5-.22-.5-.5V17.22c0-.28,.22-.5,.5-.5H49.72c.28,0,.5,.22,.5,.5V61.22c0,.28-.22,.5-.5,.5Zm-37.2-1H49.22V17.72H12.52V60.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.56,17.54l-11.71,16.69c-.04,.1-.12,.16-.21,.16H.74c-.18,0-.29-.24-.21-.44L11.99,17.42c.04-.1,.12-.16,.21-.16l37.16-.16c.18,0,.29,.24,.21,.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.86,55.04h-.06c-.12-.03-.19-.16-.15-.27l.72-2.52c.03-.12,.16-.19,.27-.16,0,0,0,0,0,0,.12,.03,.19,.16,.15,.27l-.73,2.52c-.03,.09-.12,.16-.21,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.77,56.78h-.06c-.12-.03-.19-.16-.16-.27,0,0,0,0,0,0l1.44-5.03c.03-.12,.15-.19,.27-.16,0,0,0,0,0,0,.12,.03,.19,.16,.16,.27,0,0,0,0,0,0l-1.44,5.03c-.03,.1-.12,.16-.21,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.1,
    y: 45.08,
    width: 16.62,
    height: 9.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.72,54.92H16.1c-.25,0-.45-.2-.45-.45v-9.55c0-.25,.19-.45,.44-.45,0,0,0,0,.01,0h16.62c.25,0,.45,.2,.45,.45v9.55c0,.25-.2,.45-.45,.45Zm-16.17-.91h15.71v-8.65h-15.71v8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.87,48.15h-9.92c-.15,0-.28-.12-.28-.28s.12-.28,.28-.28h9.92c.15,0,.28,.12,.28,.28s-.12,.28-.28,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.48,50.17h-7.53c-.15,0-.28-.12-.28-.28s.12-.28,.28-.28h7.53c.15,0,.28,.12,.28,.28s-.12,.28-.28,.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.41,52.19h-4.46c-.15,0-.28-.12-.28-.28s.12-.28,.28-.28h4.46c.15,0,.28,.12,.28,.28s-.12,.28-.28,.28h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.51,17.55l11.71,16.69c.04,.1,.12,.16,.21,.16h23.36c.18,0,.29-.24,.21-.44l-11.46-16.53c-.04-.1-.12-.16-.21-.16l-23.6-.16c-.18,0-.29,.24-.21,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.78,34.9h-4.37c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h3.93l-11.19-16.13-22.99-.16,11.42,16.29h15.9c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5h-16.06c-.26,0-.51-.16-.64-.4l-11.69-16.66s-.04-.06-.05-.09c-.11-.27-.09-.58,.07-.81,.14-.21,.33-.33,.6-.33l23.6,.16c.27,0,.51,.16,.64,.41l11.44,16.5s.04,.06,.05,.1c.11,.26,.08,.57-.08,.8-.14,.21-.35,.33-.59,.33Zm-11.47-17.13h0Zm-23.6-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.58,61.72h-19.45c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h18.95v-25.84c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v26.34c0,.28-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.2,34.57H1.76c-.4,0-.76-.22-.94-.57s-.16-.77,.07-1.1l10.01-14.5c.33-.48,1-.6,1.48-.27,.48,.33,.61,1,.27,1.48L3.8,32.44H24.2c.59,0,1.07,.48,1.07,1.07s-.48,1.07-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.65,34.89H.74c-.24,0-.46-.12-.59-.33-.16-.23-.18-.54-.08-.8,.01-.03,.03-.06,.05-.09L11.55,17.17c.13-.25,.37-.41,.64-.41l37.16-.16h0c.24,0,.46,.12,.6,.33,.16,.24,.18,.55,.07,.81-.01,.03-.03,.06-.05,.09l-8.4,11.98c-.16,.23-.47,.28-.7,.12-.23-.16-.28-.47-.12-.7l8.16-11.63-36.55,.16L1.18,33.89H37.5l1.54-2.21c.16-.23,.47-.28,.7-.12,.23,.16,.28,.47,.12,.7l-1.59,2.27c-.07,.19-.33,.37-.62,.37Zm-.21-.92s-.03,.04-.04,.06l.04-.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccess);
export default __webpack_public_path__ + "static/media/order-success.a776bf0d5e8b0aab35121b8a0a28a98d.svg";
export { ForwardRef as ReactComponent };